<template>
<w-settings-detail :title="title" :menu="menu" :default-active-menu="defaultMenu" @change="onChangeMenu">
  <component slot="activeView" :is="activeMenu"></component>
</w-settings-detail>
</template>

<script>
import forEach from 'lodash/forEach';
import findIndex from 'lodash/findIndex';
import WSettingsDetail from '@/components/template/SettingsDetail';
import WNetworkScheduleSettings from './NetworkScheduleSettings';
import WDatabaseScheduleSettings from './DatabaseScheduleSettings';
import WServerScheduleSettings from './ServerScheduleSettings';
import WScheduleHistory from './ScheduleHistory';

const defaultMenu = 'WServerScheduleSettings';
const menuTemplate = [
  {
    id: 'WServerScheduleSettings',
    managetypeId: 'SMS',
  },
  {
    id: 'WNetworkScheduleSettings',
    managetypeId: 'NMS',
  },
  {
    id: 'WDatabaseScheduleSettings',
    managetypeId: 'DBMS',
  },
  {
    id: 'WScheduleHistory',
    managetypeId: 'NMS',
    name: '스케줄 수행 이력',
  },
];

export default {
  name: 'WScheduleSettings',
  components: {
    WSettingsDetail,
    WNetworkScheduleSettings,
    WDatabaseScheduleSettings,
    WServerScheduleSettings,
    WScheduleHistory,
  },
  props: {
    title: String,
  },
  data() {
    return {
      defaultMenu,
      activeMenu: defaultMenu,
    };
  },
  computed: {
    menu() {
      const activeManagetypes = this.$store.getters.activeManagetypes;
      const menu = [];
      forEach(menuTemplate, (item) => {
        const index = findIndex(activeManagetypes, (managetype) => item.managetypeId === managetype.managetypeId);
        if (index >= 0) {
          menu.push({
            id: item.id,
            name: item.name ? item.name : activeManagetypes[index].managetypeName,
            active: false,
          });
        }
      });
      return menu;
    },
  },
  watch: {
    menu: {
      immediate: true,
      handler(to) {
        if (to && to.length > 0) {
          const defaultMenuId = to[0].id;
          this.defaultMenu = defaultMenuId;
          this.activeMenu = defaultMenuId;
        }
      },
    },
  },
  methods: {
    onChangeMenu(menu) {
      this.activeMenu = menu;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/ScheduleSettings/index.vue